import React from 'react';
import { Grid, Button, Tooltip } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
const AppsCard = ({item}) => {
    return(
        <Grid item md={4}>
            <div className={`application-card ${!item.access ? 'no-access-app' : ''}`} onClick={(e) => {(item.access && !item.isLessorMatched) ? window.open(item.url, '_blank').focus(): window.open(item.leaseRevampUrl, '_blank').focus();}}>
                {!item.access ? <Tooltip title='' arrow><LockIcon className='lock-icon' fontSize='small' color='primary' /></Tooltip>:null}
                <div className='app-title flex-centered'>
                    <img src={item.logo} alt={item.label}/>
                    <h4>
                        {item.label}
                        {item.isBeta ? <sup>Beta</sup>:null}
                    </h4>
                </div>
                <div className='app-desc'>
                    <p>{item.description}</p>
                </div>
                 {item.access ? (
                    item?.isLessorMatched ? (
                        <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', bottom: '10px', left: '20px', right: '20px' }} onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
                            <div style={{ position: 'relative', display: 'inline-flex' }}>
                                <span style={{ position: 'absolute', top: '-10px', right: '-8px', display: 'flex', alignItems: 'center', gap: '2px', background: '#e53935', color: '#fff', fontSize: '8px', borderRadius: '8px', padding: '0px 3px', lineHeight: '14px', whiteSpace: 'nowrap', zIndex: 1 }}>
                                    <LockIcon style={{ fontSize: '8px' }} /> Read Only
                                </span>
                                <Button size='small' endIcon={<ChevronRightIcon fontSize='small' />} style={{ fontWeight: 300, color: 'rgb(215 213 206)', position: 'relative', bottom: 'auto', left: 'auto' }} onClick={(e) => { e.stopPropagation(); window.open(item.url, '_blank').focus(); }}>Legacy</Button>
                            </div>
                            <Button size='small' endIcon={<ChevronRightIcon fontSize='small' />} style={{ position: 'relative', bottom: 'auto', left: 'auto' }} onClick={(e) => { e.stopPropagation(); window.open(item.leaseRevampUrl, '_blank').focus(); }}>Modern</Button>
                        </div>
                    ) : (
                        <Button size='small' endIcon={<ChevronRightIcon fontSize='small' />}>Access</Button>
                    )
                ) : <span className='no-access-content'>Please contact support@sparta.aero to access this application</span>}
            </div>
        </Grid>
    )
}
export default AppsCard;